import { RootState } from "store";

const migration2 = (state: RootState) => {
    return {
        ...state,
        auth: {
            ...state.auth,
        },
    };
};

export default migration2;
